import axios from 'axios';

const basename = window.location.pathname.startsWith('/my-sisense') ? '/my-sisense' : '/';
const instance = axios.create({
    baseURL: basename
});


instance.interceptors.response.use((response) => response, (error) => {
    const { response } = error;
    return Promise.reject(response || error);
});

export default instance;